import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17440356"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "canvas",
  class: "md:overflow-hidden flex flex-col md:flex-row h-auto bg-white flex-1"
};
const _hoisted_2 = {
  class: "px-5"
};
const _hoisted_3 = {
  class: "flex flex-1 p-5 flex-col flex bg-grid-slate-100 bg-slate-50 justify-between"
};
const _hoisted_4 = {
  class: "flex-1 overflow-y-auto flex justify-between flex-col sm:flex-row mb-20 md:mb-0"
};
const _hoisted_5 = {
  class: "flex flex-auto justify-center"
};
const _hoisted_6 = {
  key: 2,
  class: "absolute text-indigo-500",
  style: {
    "z-index": "2005",
    "top": "calc(50% + 30px)"
  }
};
const _hoisted_7 = {
  class: "mt-2 flex-none mx-auto flex justify-center break-words border border-gray-300 rounded p-2 text-xs w-full sm:w-1/3 2xl:w-1/6 md:ml-2 overflow-auto flex flex-col justify-between max-w-sm"
};
const _hoisted_8 = {
  class: "my-2 font-bold flex justify-between items-center"
};
const _hoisted_9 = {
  class: "flex-auto"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-xs"
}, "英文关键词", -1));
const _hoisted_11 = {
  class: "text-gray-500 text-xs"
};
const _hoisted_12 = {
  class: "border border-gray-300 rounded p-1.5 text-gray-500 text-container"
};
const _hoisted_13 = {
  class: "my-2 font-bold flex justify-between items-center"
};
const _hoisted_14 = {
  class: "flex-auto"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-xs"
}, "原始关键词", -1));
const _hoisted_16 = {
  class: "text-gray-500 text-xs"
};
const _hoisted_17 = {
  class: "text-container border border-gray-300 rounded p-1.5 text-gray-500"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mt-5 font-bold"
}, "放大图片", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-gray-500"
}, "对左侧的其中一张图片进行放大", -1));
const _hoisted_20 = {
  class: "flex justify-between text-center mt-2 select-none sm:flex-wrap"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mt-2 font-bold"
}, "变体图片", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-gray-500"
}, "对左侧的其中一张图片进行多样化修改", -1));
const _hoisted_24 = {
  class: "flex justify-between text-center mt-2 select-none sm:flex-wrap"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "mt-3 flex justify-start text-center select-none flex-wrap"
};
const _hoisted_27 = {
  class: "text-center mt-2 text-gray-300"
};
const _hoisted_28 = {
  class: "send hover:shadow active:shadow focus:shadow bg-slate-50 hover:border-indigo-600 active:border-indigo-600 p-2 text-xs flex-none box-border rounded-2xl w-full border-gray-300 border mt-5 flex items-center justify-between"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_slider_bar = _resolveComponent("slider-bar");
  const _component_ai_upload_img = _resolveComponent("ai-upload-img");
  const _component_Loading = _resolveComponent("Loading");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_image = _resolveComponent("el-image");
  const _component_img_cropping = _resolveComponent("img-cropping");
  const _component_CopyDocument = _resolveComponent("CopyDocument");
  const _component_Star = _resolveComponent("Star");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Share = _resolveComponent("Share");
  const _component_Scissor = _resolveComponent("Scissor");
  const _component_Delete = _resolveComponent("Delete");
  const _component_el_input = _resolveComponent("el-input");
  const _component_MagicStick = _resolveComponent("MagicStick");
  const _component_Promotion = _resolveComponent("Promotion");
  const _component_setting_bar = _resolveComponent("setting-bar");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_component_slider_bar, {
    modelValue: _ctx.historyActive,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.historyActive = $event),
    history: _ctx.history,
    load: _ctx.getHistory,
    finish: _ctx.historyFinish,
    ref: "historyBar"
  }, null, 8, ["modelValue", "history", "load", "finish"]), [[_directive_loading, _ctx.historyLoading]]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_ai_upload_img, {
    class: "sm:hidden"
  })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [!_ctx.isIc ? _withDirectives((_openBlock(), _createBlock(_component_el_image, {
    key: 0,
    class: "mx-auto max-w-fit",
    fit: "contain",
    "preview-src-list": [_ctx.currentTask.img],
    src: _ctx.currentTask.img
  }, {
    placeholder: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "animate-spin"
    }, {
      default: _withCtx(() => [_createVNode(_component_Loading)]),
      _: 1
    })]),
    _: 1
  }, 8, ["preview-src-list", "src"])), [[_vShow, _ctx.currentTask.img]]) : _createCommentVNode("", true), _ctx.currentTask.leixing !== _ctx.ACTION_TYPE.UPSCALE && _ctx.isIc ? (_openBlock(), _createBlock(_component_img_cropping, {
    key: 1,
    class: "flex mx-auto max-w-fit",
    ref: "ic",
    img: _ctx.currentTask.img,
    onError: _cache[1] || (_cache[1] = $event => _ctx.isIc = false)
  }, null, 8, ["img"])) : _createCommentVNode("", true), _ctx.drawLoading ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.drawProgress), 1)) : _createCommentVNode("", true)])), [[_directive_loading, _ctx.drawLoading]]), _withDirectives(_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_icon, {
    onClick: _cache[2] || (_cache[2] = $event => _ctx.copyToClipboard(_ctx.currentTask.en_miaoshuchi)),
    class: "ml-1 text-gray-500 cursor-pointer relative top-0.5"
  }, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })]), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.dayjs(_ctx.currentTask.time * 1000).fromNow()), 1)]), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.currentTask.en_miaoshuchi), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_el_icon, {
    onClick: _cache[3] || (_cache[3] = $event => _ctx.copyToClipboard(_ctx.currentTask.miaoshuchi)),
    class: "ml-1 text-gray-500 cursor-pointer relative top-0.5"
  }, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })]), _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.dayjs(_ctx.currentTask.time * 1000).fromNow()), 1)]), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.currentTask.miaoshuchi), 1), _withDirectives(_createElementVNode("div", null, [_hoisted_18, _hoisted_19, _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.UPSCALE_TYPES, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "uv-btn",
      key: item.value,
      onClick: $event => _ctx.send(_ctx.ACTION_TYPE.UPSCALE, item.value)
    }, _toDisplayString(item.name), 9, _hoisted_21);
  }), 128))]), _hoisted_22, _hoisted_23, _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.VARIATION_TYPES, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "uv-btn",
      key: item.value,
      onClick: $event => _ctx.send(_ctx.ACTION_TYPE.VARIATION, item.value)
    }, _toDisplayString(item.name), 9, _hoisted_25);
  }), 128))])], 512), [[_vShow, _ctx.currentTask.leixing !== _ctx.ACTION_TYPE.UPSCALE && _ctx.currentTask.img]]), _createElementVNode("div", _hoisted_26, [_ctx.currentTask.img ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_withDirectives(_createVNode(_component_el_button, {
    loading: _ctx.collectLoading,
    class: "action-btn",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.collect(_ctx.currentTask.renwu_id))
  }, {
    default: _withCtx(() => [_createTextVNode(" 收藏 "), _createVNode(_component_el_icon, {
      class: "ml-0.5"
    }, {
      default: _withCtx(() => [_createVNode(_component_Star)]),
      _: 1
    })]),
    _: 1
  }, 8, ["loading"]), [[_vShow, _ctx.currentTask.leixing === _ctx.ACTION_TYPE.UPSCALE]]), _withDirectives(_createVNode(_component_el_button, {
    loading: _ctx.shareLoading,
    class: "action-btn",
    onClick: _cache[5] || (_cache[5] = $event => _ctx.share(_ctx.currentTask.renwu_id))
  }, {
    default: _withCtx(() => [_createTextVNode(" 分享 "), _createVNode(_component_el_icon, {
      class: "ml-0.5"
    }, {
      default: _withCtx(() => [_createVNode(_component_Share)]),
      _: 1
    })]),
    _: 1
  }, 8, ["loading"]), [[_vShow, _ctx.currentTask.leixing === _ctx.ACTION_TYPE.UPSCALE]]), _withDirectives(_createVNode(_component_el_button, {
    onClick: _ctx.crop,
    class: "action-btn"
  }, {
    default: _withCtx(() => [_createTextVNode(" 一键切图 "), _createVNode(_component_el_icon, {
      class: "ml-0.5"
    }, {
      default: _withCtx(() => [_createVNode(_component_Scissor)]),
      _: 1
    })]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, _ctx.currentTask.leixing !== _ctx.ACTION_TYPE.UPSCALE]])], 64)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
    loading: _ctx.delLoading,
    class: "action-btn text-red-600",
    onClick: _cache[6] || (_cache[6] = $event => _ctx.del(_ctx.currentTask.renwu_id))
  }, {
    default: _withCtx(() => [_createTextVNode(" 删除 "), _createVNode(_component_el_icon, {
      class: "ml-0.5"
    }, {
      default: _withCtx(() => [_createVNode(_component_Delete)]),
      _: 1
    })]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_27, " 任务ID：" + _toDisplayString(_ctx.currentTask.renwu_id), 1)], 512), [[_vShow, _ctx.currentTask.renwu_id]])]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_input, {
    ref: "textarea",
    type: "textarea",
    modelValue: _ctx.promptParams.text,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.promptParams.text = $event),
    autosize: {
      minRows: 1,
      maxRows: 3
    },
    resize: "none",
    class: "h-full bg-transparent text-xs flex items-center",
    placeholder: "请输入您的描述"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
    disabled: !_ctx.promptParams.text.trim(),
    class: "border-none rounded-2xl border-sky-500/10 bg-sky-500/10 text-sky-500 text-xs mr-1 hover:bg-sky-500/20 hover:text-sky-500",
    color: "rgba(14 165 233 ,0.1)",
    onClick: _ctx.beautifulWords,
    loading: _ctx.beautifulLoading || _ctx.writing
  }, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_el_icon, {
      class: "text-inherit mr-0.5"
    }, {
      default: _withCtx(() => [_createVNode(_component_MagicStick)]),
      _: 1
    }, 512), [[_vShow, !_ctx.beautifulLoading && !_ctx.writing]]), _createTextVNode("优化关键词 ")]),
    _: 1
  }, 8, ["disabled", "onClick", "loading"]), _createVNode(_component_el_button, {
    loading: _ctx.taskLoading,
    onClick: _cache[8] || (_cache[8] = $event => _ctx.send(_ctx.ACTION_TYPE.IMAGINE, 0)),
    disabled: !_ctx.submitPrompt.trim(),
    color: "rgb(99 102 241)",
    class: "border-none cursor-pointer h-8 bg-indigo-500/10 w-20 rounded-2xl text-indigo-500 p-2 flex justify-center items-center hover:bg-indigo-500/20 hover:text-indigo-500"
  }, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_el_icon, {
      class: "text-inherit"
    }, {
      default: _withCtx(() => [_createVNode(_component_Promotion)]),
      _: 1
    }, 512), [[_vShow, !_ctx.taskLoading]])]),
    _: 1
  }, 8, ["loading", "disabled"])])]), _createVNode(_component_setting_bar, {
    ratio: _ctx.promptParams.ratio,
    "onUpdate:ratio": _cache[9] || (_cache[9] = $event => _ctx.promptParams.ratio = $event),
    keywords: _ctx.promptParams.keywords,
    "onUpdate:keywords": _cache[10] || (_cache[10] = $event => _ctx.promptParams.keywords = $event),
    img_urls: _ctx.promptParams.img_urls,
    "onUpdate:img_urls": _cache[11] || (_cache[11] = $event => _ctx.promptParams.img_urls = $event)
  }, null, 8, ["ratio", "keywords", "img_urls"])]);
}